import React, { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const INVALID_DATE = "1900-01-01T00:00:00";

const PowerTableComponent = ({ report = [], meters = [] }) => {
  const { isdarkMode } = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);

  const columns = useMemo(() => {
    return meters.map((col) => ({
      headerName: col.title,
      field: col.dataIndex,
      minWidth: col.minWidth || 150,
      flex: 1,
      valueFormatter: (params) => {
        const value = params.value;

        if (!value) return "--";

        // Handle invalid placeholder date
        // if (value === INVALID_DATE) return "--";

        // Detect ISO date strings
        if (
          typeof value === "string" &&
          value.includes("T") &&
          dayjs(value).isValid()
        ) {
          return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
        }

        return value;
      },
    }));
  }, [meters]);

  return (
    <div
      className={isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}
      style={{
        "--ag-header-background-color": color.themeConfig.colorPrimary,
        "--ag-header-foreground-color": "#fff",
        height: "80vh",
        width: "100%",
      }}
    >
      <AgGridReact
        rowData={report}
        columnDefs={columns}
        defaultColDef={{
          resizable: true,
          sortable: true,
          filter: true,
        }}
        pagination
        paginationPageSize={20}
        rowHeight={48}
      />
    </div>
  );
};

export default PowerTableComponent;
